import { CheckoutEvents } from '@mc/pre-paywall-events'
import { track, getPageSource } from '@mc/track-event'
import { Location } from './data'

export const trackPopUpViewed = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'viewed',
    location: Location.POP_UP,
    page_source: getPageSource(),
  })
}

export const trackPopUpClosed = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'dismiss',
    location: Location.POP_UP,
    page_source: getPageSource(),
  })
}

export const trackPopUpTappedOutside = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'tap_outside',
    location: Location.POP_UP,
    page_source: getPageSource(),
  })
}

export const trackSignUpWithEmailClicked = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'click',
    name: 'Sign up with email',
    location: Location.POP_UP,
    page_source: getPageSource(),
  })
}

export const trackLogInClicked = () => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN, {
    action: 'click',
    name: 'Login',
    location: Location.POP_UP,
    page_source: getPageSource(),
  })
}
